import { CONTACT } from '../config/contact';
import { formatPrice } from './formatPrice';

export function formatCartItemLine(item) {
  const extras = item.selectedExtras.map((extra) => extra.name).join(', ');
  const drinks = (item.selectedDrinks || []).map((drink) => drink.name).join(', ');
  const removed = item.removedIncluded.map((ing) => ing.name).join(', ');
  const included = item.selectedIncluded.map((ing) => ing.name).join(', ');
  const parts = [`• ${item.quantity}x ${item.name} (${formatPrice(item.lineTotal)})`];

  if (included) parts.push(`  Inclus : ${included}`);
  if (extras) parts.push(`  + ${extras}`);
  if (drinks) parts.push(`  + ${drinks}`);
  if (removed) parts.push(`  Sans : ${removed}`);
  if (item.notes) parts.push(`  Note : ${item.notes}`);

  return parts.join('\n');
}

export function buildOrderMessage(items, totalPrice) {
  const lines = items.map(formatCartItemLine).join('\n\n');

  return [
    'Bonjour DoWhile Food !',
    '',
    'Je souhaite passer commande :',
    '',
    lines,
    '',
    `Total : ${formatPrice(totalPrice)}`,
    '',
    'Merci !',
  ].join('\n');
}

export function getWhatsAppOrderUrl(items, totalPrice) {
  const text = encodeURIComponent(buildOrderMessage(items, totalPrice));
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${text}`;
}

export function getWhatsAppUrl(message = '') {
  if (!message) {
    return `https://wa.me/${CONTACT.whatsappNumber}`;
  }
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
